const schema = {
  balanceEntries: {
    type: "balanceEntries",
    fields: {
      id: "number",
      amount: "number",
      balanceEvent: "number",
      balanceRegistration: "number",
      balanceStuff: "number",
      timestamp: "date",
    },
    relationships: {
      person: {
        type: "people",
      },
    },
  },
  events: {
    type: "events",
    fields: {
      id: "number",
      date: "date",
    },
  },
  eventOrganizations: {
    type: "eventOrganizations",
    fields: {
      id: "number",
    },
  },
  eventParticipations: {
    type: "eventParticipations",
    fields: {
      id: "number",
    },
  },
  families: {
    type: "families",
    fields: {
      id: "number",
    },
  },
  familyMemberships: {
    type: "familyMemberships",
    fields: {
      id: "number",
    },
  },
  payments: {
    type: "payments",
    fields: {
      id: "number",
      timestamp: "date",
    },
    relationships: {
      event: {
        type: "events",
      },
      person: {
        type: "people",
      },
    },
  },
  people: {
    type: "people",
    fields: {
      id: "number",
    },
  },
  registrations: {
    type: "registrations",
    fields: {
      id: "number",
    },
  },
  registrationLevels: {
    type: "registrationLevels",
    fields: {
      id: "number",
    },
  },
};

export default schema;
